import React, {useState} from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import "./AddFundsConfirmation.style.scss";
import {_t} from "../../../../../utils/I18nUtils";
import {FormattedMessage} from "react-intl";

const AddFundsConfirmation = ({vm, product, onUserAgreed}) => {
    const [userAgreed, setUserAgreed] = useState(false);
    const onTermChange = (e) =>{
        onUserAgreed(!userAgreed);
        setUserAgreed(!userAgreed)
    }

    const trKey = "components.addFundsForm.confirmation";
    return <div className="AddFundsConfirmation *&&">
        <div className="confirmOrder">
            <table>
                <tbody>
                <tr>
                    <td colSpan="2">{_t(`${trKey}.productPriceLabel`)}</td>
                    <td className="text-right">$ {product?.price?.toFixed(2)}</td>
                </tr>
                </tbody>
            </table>

            <div className="sepLine"></div>

            <table>
                <tbody>
                <tr>
                    <td className="lightLabel">{_t(`${trKey}.cardNameLabel`)}</td>
                    <td>{vm.ccInfo.fname} {vm.ccInfo.lname}</td>
                </tr>
                <tr valign="top">
                    <td className="lightLabel">{_t(`${trKey}.billingAddressLabel`)}</td>
                    <td>
                        {vm.ccInfo.address}<br/>
                        {vm.ccInfo.city} , {vm.ccInfo.state}, {vm.ccInfo.zip}<br/>
                        {vm.ccInfo.country}
                    </td>
                </tr>
                <tr>
                    <td className="lightLabel">{_t(`${trKey}.phoneLabel`)}</td>
                    <td>{vm.ccInfo.phone}</td>
                </tr>
                <tr>
                    <td className="lightLabel">{_t(`${trKey}.tradeFanAccountLabel`)}</td>
                    <td>{vm.account.email} ({vm.account.pseudonym})</td>
                </tr>
                </tbody>
            </table>

            <div className="sepLine"></div>

            <div className="checkbox">
                <input type="checkbox" id="term1" name="term1" onChange={onTermChange} checked={userAgreed}/>
                <label htmlFor="term1">{_t(`${trKey}.iAgreeWithLabel`)} <Link to={"/TermsOfUse"}>
                    <FormattedMessage id={`${trKey}.termsOfUseLabel`}/>
                </Link>
                </label>
            </div>
        </div>
            </div>;

}

AddFundsConfirmation.propTypes ={
    product: PropTypes.object,
    onUserAgreed: PropTypes.func,
};

export default AddFundsConfirmation;
